(ns teamoesterreich.user-mode.widgets.fb-plugin
  (:require [clojure.string]
            [reagent.core :as r]
            ))




(defn fb-plugin []
  (r/create-class
    {
     :reagent-render       (fn [] [:div.fb-page
                                   {:data-href                  "https://www.facebook.com/teambayern.info"
                                    :data-tabs                  "timeline"
                                    :data-width                 "930"
                                    :data-height                "930"
                                    :data-small-header          "true"
                                    :data-adapt-container-width "false"
                                    :data-hide-cover            "false"
                                    :data-show-facepile         "true"}
                                   [:blockquote.fb-xfbml-parse-ignore
                                    {:cite "https://www.facebook.com/teambayern.info"}
                                    [:a {:href "https://www.facebook.com/teambayern.info"} "Team Bayern"]]])

     :component-did-mount  (fn [comp]
                             (try (-> js/FB .-XFBML .parse)
                                  (catch js/Error e [:span "---"])
                                  ))
     :component-did-update (fn [params]

                             )

     :display-name         "facebook_plugin"}))


